(function(){
  var d = document, h = d.documentElement;
  h.classList.add('mk-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function ready(fn){ d.readyState !== 'loading' ? fn() : d.addEventListener('DOMContentLoaded', fn); }
  function esc(s){ return s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function toast(msg){
    var t = d.querySelector('.mk-toast'); if (!t) return;
    t.querySelector('.mk-toast__msg').textContent = msg;
    t.hidden = false;
    requestAnimationFrame(function(){ t.classList.add('is-in'); });
    clearTimeout(t._t);
    t._t = setTimeout(function(){ t.classList.remove('is-in'); setTimeout(function(){ t.hidden = true; }, 450); }, 3200);
  }

  function addToCart(opts){
    var drawer = d.querySelector('cart-drawer');
    var init = { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
    if (opts.items) {
      var body = { items: opts.items };
      if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = location.pathname; }
      init.headers['Content-Type'] = 'application/json';
      init.body = JSON.stringify(body);
    } else {
      var fd = opts.formData;
      if (fd.has('selling_plan') && !fd.get('selling_plan')) fd.delete('selling_plan');
      if (drawer) { fd.append('sections', 'cart-drawer,cart-icon-bubble'); fd.append('sections_url', location.pathname); }
      init.body = fd;
    }
    if (opts.btn) opts.btn.classList.add('is-loading');
    return fetch(root + 'cart/add.js', init)
      .then(function(r){ return r.json().then(function(j){ return { ok: r.ok, j: j }; }); })
      .then(function(res){
        if (opts.btn) opts.btn.classList.remove('is-loading');
        if (!res.ok) { toast(res.j.description || res.j.message || 'That could not be added.'); return false; }
        if (drawer && typeof drawer.renderContents === 'function' && res.j.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res.j);
        } else {
          toast(opts.items ? 'Your bundle is in the bag.' : 'Added to your bag.');
        }
        return true;
      })
      .catch(function(){ if (opts.btn) opts.btn.classList.remove('is-loading'); if (opts.fallback) opts.fallback(); });
  }

  function splitWords(el, start){
    var words = el.textContent.trim().split(/\s+/);
    el.innerHTML = words.map(function(w, i){
      return '<span class="mk-w"><span style="transition-delay:' + ((start + i) * 70) + 'ms">' + esc(w) + '</span></span>';
    }).join(' ');
    return words.length;
  }

  function initPopup(){
    var pop = d.getElementById('mk-pop'); if (!pop) return;
    var KEY = 'mk_pop_v1', state = {};
    try { state = JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch(e) { state = {}; }
    function save(){ try { localStorage.setItem(KEY, JSON.stringify(state)); } catch(e) {} }
    var tab = d.querySelector('[data-pop-open]');
    var form = d.getElementById('mk-pop-form');
    var code = pop.getAttribute('data-code') || '';
    var path = location.pathname;
    var excluded = /^\/pages\/for-/.test(path) || /^\/(cart|checkout|account|challenge)/.test(path);
    var lastFocus = null;

    function step(n){ pop.querySelectorAll('[data-step]').forEach(function(s){ s.classList.toggle('is-active', +s.dataset.step === n); }); }
    function open(){
      if (!pop.hidden) return;
      lastFocus = d.activeElement;
      pop.hidden = false; step(1);
      requestAnimationFrame(function(){ pop.classList.add('is-open'); });
      h.classList.add('mk-lock');
      if (tab) tab.hidden = true;
      var first = pop.querySelector('.mk-pop__opt'); if (first) setTimeout(function(){ first.focus(); }, 300);
    }
    function close(){
      pop.classList.remove('is-open'); h.classList.remove('mk-lock');
      setTimeout(function(){ pop.hidden = true; }, 500);
      if (!state.done) { state.dismissed = Date.now(); save(); if (tab) tab.hidden = false; }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function go(){
      var url = state.url || '/';
      location.href = code ? (root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(url)) : url;
    }

    if (/customer_posted=true/.test(location.search) && state.persona && !state.done) {
      state.done = true; save();
      pop.hidden = false; pop.classList.add('is-open'); h.classList.add('mk-lock'); step(3);
      setTimeout(go, 1600);
      return;
    }

    pop.querySelectorAll('[data-pop-close]').forEach(function(b){ b.addEventListener('click', function(e){ if (e.target === b || b.tagName === 'BUTTON') close(); }); });
    d.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !pop.hidden) close(); });
    var back = pop.querySelector('[data-pop-back]'); if (back) back.addEventListener('click', function(){ step(1); });
    if (tab) tab.addEventListener('click', open);

    pop.querySelectorAll('.mk-pop__opt').forEach(function(b){
      b.addEventListener('click', function(){
        state.persona = b.dataset.label; state.url = b.dataset.url; state.tag = b.dataset.tag; save();
        var tags = pop.querySelector('[data-pop-tags]'); if (tags) tags.value = 'newsletter,popup,persona-' + b.dataset.tag;
        var pl = pop.querySelector('[data-pop-persona]'); if (pl) pl.textContent = b.dataset.label;
        step(2);
        var em = form && form.querySelector('input[type=email]'); if (em) setTimeout(function(){ em.focus(); }, 250);
      });
    });

    if (form) form.addEventListener('submit', function(e){
      e.preventDefault();
      var btn = form.querySelector('[type=submit]'); if (btn) btn.classList.add('is-loading');
      save();
      fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
        .then(function(r){
          if (/challenge/.test(r.url)) { HTMLFormElement.prototype.submit.call(form); return; }
          state.done = true; save(); step(3); setTimeout(go, 1600);
        })
        .catch(function(){ HTMLFormElement.prototype.submit.call(form); });
    });

    if (state.done || excluded) return;
    var recent = state.dismissed && (Date.now() - state.dismissed < 3 * 864e5);
    if (recent) { if (tab) tab.hidden = false; return; }
    var delay = (+pop.getAttribute('data-delay') || 8) * 1000;
    var timer = setTimeout(open, delay);
    d.addEventListener('mouseout', function onOut(e){
      if (!e.relatedTarget && e.clientY <= 0) { clearTimeout(timer); open(); d.removeEventListener('mouseout', onOut); }
    });
  }

  ready(function(){
    var b = d.body;
    var main = d.querySelector('main');
    var first = main && main.querySelector('.shopify-section');
    var ov = first && first.querySelector('[data-mk-overlay]');
    if (ov) { b.classList.add('mk-overlay'); if (ov.getAttribute('data-mk-overlay') === 'light') b.classList.add('mk-overlay-light'); }
    var hdr = d.querySelector('.section-header');
    function setH(){ if (hdr) h.style.setProperty('--mk-header-h', hdr.offsetHeight + 'px'); }
    setH(); window.addEventListener('resize', setH);
    function onScroll(){ b.classList.toggle('mk-scrolled', window.scrollY > 60); }
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });

    d.querySelectorAll('.mk-split').forEach(function(el){
      if (el.dataset.split) return; el.dataset.split = '1';
      var lines = el.querySelectorAll('.mk-line');
      if (lines.length) { var n = 0; lines.forEach(function(l){ n += splitWords(l, n); }); }
      else splitWords(el, 0);
    });

    var els = d.querySelectorAll('.mk-reveal, .mk-split, .mk-stagger');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function(e){ e.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(x){ if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
      els.forEach(function(e){ io.observe(e); });
    }

    var px = [].slice.call(d.querySelectorAll('[data-mk-parallax] .mk-parallax'));
    if (px.length && !reduce) {
      var ticking = false;
      var run = function(){
        px.forEach(function(el){
          var host = el.closest('[data-mk-parallax]');
          var r = host.getBoundingClientRect();
          if (r.bottom < 0 || r.top > innerHeight) return;
          var p = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
          el.style.transform = 'translate3d(0,' + (p * -7).toFixed(2) + '%,0) scale(1.12)';
        });
        ticking = false;
      };
      window.addEventListener('scroll', function(){ if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
      run();
    }

    d.querySelectorAll('.mk-ritual').forEach(function(s){
      var steps = s.querySelectorAll('.mk-ritual__step'), imgs = s.querySelectorAll('.mk-ritual__img');
      if (!('IntersectionObserver' in window)) return;
      var o = new IntersectionObserver(function(entries){
        entries.forEach(function(x){
          if (!x.isIntersecting) return;
          var i = +x.target.dataset.index;
          steps.forEach(function(st, j){ st.classList.toggle('is-active', j === i); });
          imgs.forEach(function(im, j){ im.classList.toggle('is-active', j === i); });
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach(function(st){ o.observe(st); });
    });

    d.querySelectorAll('.mk-gallery').forEach(function(g){
      var track = g.querySelector('.mk-gallery__track'), dots = g.querySelectorAll('.mk-gallery__dot');
      if (!track || !dots.length) return;
      track.addEventListener('scroll', function(){
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function(dt, j){ dt.classList.toggle('is-active', j === i); });
      }, { passive: true });
      dots.forEach(function(dt, j){ dt.addEventListener('click', function(){ track.scrollTo({ left: j * track.clientWidth, behavior: 'smooth' }); }); });
    });

    d.querySelectorAll('.mk-qty').forEach(function(q){
      var input = q.querySelector('input');
      q.querySelectorAll('button').forEach(function(bt){
        bt.addEventListener('click', function(){ input.value = Math.max(1, (+input.value || 1) + (+bt.dataset.step)); });
      });
    });

    d.querySelectorAll('[data-mk-sub]').forEach(function(s){
      var form = d.getElementById(s.getAttribute('data-form'));
      s.addEventListener('change', function(e){
        var r = e.target; if (r.type !== 'radio') return;
        s.querySelectorAll('.mk-sub__opt').forEach(function(o){ o.classList.toggle('is-active', o.contains(r)); });
        var pi = form && form.querySelector('[data-mk-plan]'); if (pi) pi.value = r.value;
      });
    });

    d.querySelectorAll('.mk-choice').forEach(function(c){
      var form = d.getElementById(c.getAttribute('data-form'));
      var bar = d.getElementById(c.getAttribute('data-bar'));
      var sec = c.closest('.mk-pdp');
      var sub = sec && sec.querySelector('[data-mk-sub]');
      c.addEventListener('change', function(e){
        var r = e.target; if (r.type !== 'radio') return;
        c.querySelectorAll('.mk-choice__opt').forEach(function(o){ o.classList.toggle('is-active', o.contains(r)); });
        if (form) { var idIn = form.querySelector('input[name=id]'); if (idIn) { idIn.value = r.value; idIn.dispatchEvent(new Event('change', { bubbles: true })); } }
        if (sub) {
          var isSingle = r.dataset.single === '1';
          sub.hidden = !isSingle;
          if (!isSingle) { var pi = form && form.querySelector('[data-mk-plan]'); if (pi) pi.value = ''; var one = sub.querySelector('input[value=""]'); if (one) { one.checked = true; one.dispatchEvent(new Event('change', { bubbles: true })); } }
        }
        var p = sec && sec.querySelector('[data-mk-price]'); if (p) p.textContent = r.dataset.price;
        var cp = sec && sec.querySelector('[data-mk-compare]'); if (cp) { cp.textContent = r.dataset.compare || ''; cp.hidden = !r.dataset.compare; }
        if (bar) {
          var bi = bar.querySelector('input[name=id]'); if (bi) bi.value = r.value;
          var bp = bar.querySelector('[data-mk-bar-price]'); if (bp) bp.textContent = r.dataset.price;
          var bn = bar.querySelector('[data-mk-bar-name]'); if (bn && r.dataset.name) bn.textContent = r.dataset.name;
        }
      });
    });

    d.querySelectorAll('[data-mk-builder]').forEach(function(s){
      var min = +s.dataset.min || 2, pct = +s.dataset.pct || 15;
      var picks = [].slice.call(s.querySelectorAll('.mk-pick'));
      var bar = s.querySelector('[data-bar]');
      var addBtn = bar.querySelector('[data-add]');
      function fmt(c){ return '$' + (c / 100).toFixed(2); }
      function update(){
        var n = 0, sub = 0;
        picks.forEach(function(p){ var q = +p.dataset.q || 0; n += q; sub += q * (+p.dataset.price); });
        var on = n >= min;
        var total = on ? Math.round(sub * (100 - pct) / 100) : sub;
        bar.querySelector('[data-total]').textContent = fmt(total);
        var was = bar.querySelector('[data-was]'); was.hidden = !on; was.textContent = fmt(sub);
        bar.querySelector('[data-sum]').textContent = n + (n === 1 ? ' bag' : ' bags') + (on ? ' · You save ' + fmt(sub - total) : ' · Free shipping');
        bar.querySelector('[data-msg]').textContent = n === 0 ? 'Pick any ' + min + ' to save ' + pct + '%' : (on ? pct + '% off your bundle' : 'Add ' + (min - n) + ' more to save ' + pct + '%');
        bar.querySelector('[data-fill]').style.width = Math.min(100, n / min * 100) + '%';
        bar.classList.toggle('is-unlocked', on);
        addBtn.disabled = n === 0;
      }
      picks.forEach(function(p){
        function set(q){
          q = Math.max(0, Math.min(12, q));
          p.dataset.q = q;
          p.querySelector('output').textContent = q;
          p.querySelector('.mk-pick__count').textContent = q;
          p.classList.toggle('is-picked', q > 0);
          update();
        }
        p.querySelectorAll('[data-d]').forEach(function(bt){
          bt.addEventListener('click', function(){ set((+p.dataset.q || 0) + (+bt.dataset.d)); });
        });
        var media = p.querySelector('.mk-pick__media');
        if (media) media.addEventListener('click', function(){ var plus = p.querySelector('[data-d="1"]'); if (plus && !plus.disabled) set((+p.dataset.q || 0) + 1); });
      });
      addBtn.addEventListener('click', function(){
        var items = picks.filter(function(p){ return +p.dataset.q > 0; }).map(function(p){ return { id: +p.dataset.variant, quantity: +p.dataset.q }; });
        if (!items.length) return;
        addToCart({ items: items, btn: addBtn, fallback: function(){ location.href = '/cart'; } });
      });
      update();
    });

    d.querySelectorAll('[data-mk-sticky-target]').forEach(function(t){
      var bar = d.getElementById(t.getAttribute('data-mk-sticky-target'));
      if (!bar || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function(entries){
        entries.forEach(function(x){ bar.classList.toggle('is-visible', !x.isIntersecting && x.boundingClientRect.top < 0); });
      }).observe(t);
    });

    d.addEventListener('submit', function(e){
      var f = e.target;
      if (!f.classList || !f.classList.contains('mk-atc')) return;
      e.preventDefault();
      addToCart({ formData: new FormData(f), btn: e.submitter || f.querySelector('[type=submit]'), fallback: function(){ HTMLFormElement.prototype.submit.call(f); } });
    });

    initPopup();
  });
})();